export const formatTextAsSentence = (value: string) =>
  !!value ? [value[0].toUpperCase(), value.slice(1)].join('') : '-'
